import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost, type PostValue } from './client'

/**
 * "Create owner" pentru un contact necunoscut (o adresa de pe un tichet).
 *
 * Perechile vechi:
 *   Quick::unknown_contact/{id}               -> GET  /settings/owners/unknown/{id}
 *   settings/Owners::quickCreateUnknownOwner  -> POST /settings/owners/unknown/{id}
 *
 * Calea NU poarta `/api/v2`: il pune `apiGet`/`apiPost`.
 */

export type UnknownOwnerPanel = {
  contact: { id: number; address: string }
  /** DEJA filtrate pe server: ale furnizorului si la care omul are voie. */
  companies: { id: number; name: string }[]
}

export function unknownOwnerPanelQuery(contactId: number) {
  return queryOptions({
    queryKey: ['settings', 'owners', 'unknown', contactId],
    queryFn: () => apiGet<UnknownOwnerPanel>(`/settings/owners/unknown/${contactId}`),
    enabled: contactId > 0,
  })
}

export function createUnknownOwner(contactId: number, fields: Record<string, PostValue>) {
  return apiPost<{ saved: boolean; id: number; email: string }>(`/settings/owners/unknown/${contactId}`, fields)
}
